/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 22nd 2022, 11:13:13 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { ListEditorProvider, ListEditorContext } from "lib/providers";
import { ActivationCondition, NextActivation } from "lib/schemas";
import { getDefaultActivationCondition } from "lib/factories";
import { OSActionButton, APIListProgressWrapper } from "ui-widgets";
import { ActivationConditionListItem } from "./ActivationConditionListItem";

export const ActivationConditionList = ({ nextActivation }: { nextActivation: NextActivation }) => (
  <ListEditorProvider<ActivationCondition, false>
    apiServicePath="/activation-conditions/"
    apiQueryParams={{ activation: nextActivation.id }}
    uniqueIdentifier="id"
  >
    <ListEditorContext.Consumer>
      {({ itemsListState, createNewItem, isFetchingItems, fetchItemsStatusCode, fetchItemsHasError }) => (
        <APIListProgressWrapper
          showMessageWhenEmpty={false}
          items={itemsListState.savedItems}
          showLoader={isFetchingItems}
          loaderType="linear"
          httpResponseStatusCode={fetchItemsStatusCode}
          isAPIError={fetchItemsHasError}
        >
          <Stack spacing={2}>
            {itemsListState.savedItems
              .concat(itemsListState.itemCreationQueue)
              .map((activationCondition: ActivationCondition) => (
                <ActivationConditionListItem
                  key={activationCondition.id ?? (activationCondition as any).os_unsaved_item_temp_unique_id}
                  activationCondition={activationCondition}
                />
              ))}
            <OSActionButton
              actionStyle="add"
              onClick={() => createNewItem(getDefaultActivationCondition(nextActivation))}
            >
              Add Condition
            </OSActionButton>
          </Stack>
        </APIListProgressWrapper>
      )}
    </ListEditorContext.Consumer>
  </ListEditorProvider>
);
